import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Badge, Spinner, Alert } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import withRouter from "../../../common/data/withRouter";

// import images
import bgImage from "../../../assets/images/app/bg-image.png";

class PublicInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoice: null,
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.fetchInvoice();
    document.body.classList = "";
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var doc = document.documentElement;
    const navBar = document.getElementById("topnav");
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (navBar != null) {
      if (top > 80) {
        navBar.classList.add("nav-sticky");
      } else {
        navBar.classList.remove("nav-sticky");
      }
    }
  };

  fetchInvoice = async () => {
    const { token } = this.props.router.params;
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || "https://api.digitcardapp.com"}/api/invoice/public/${token}`);
      const result = await response.json();
      if (result.success) {
        this.setState({ invoice: result.data, loading: false });
      } else {
        this.setState({ error: result.message || "Invoice not found", loading: false });
      }
    } catch (err) {
      this.setState({ error: "Failed to fetch invoice details", loading: false });
    }
  };

  render() {
    const { invoice, loading, error } = this.state;

    return (
      <React.Fragment>
        <section
          className="bg-half-170 bg-light d-table w-100"
          style={{ background: `url(${bgImage}) center center` }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg={12} className="text-center">
                <div className="pages-heading">
                  <h4 className="title mb-0"> Invoice Detail </h4>
                </div>
              </Col>
            </Row>

            <div className="position-breadcrumb">
              <nav aria-label="breadcrumb" className="d-inline-block">
                <ul className="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Invoice</li>
                </ul>
              </nav>
            </div>
          </Container>
        </section>

        <div className="position-relative">
          <div className="shape overflow-hidden text-white">
            <svg
              viewBox="0 0 2880 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>

        <section className="section bg-light">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10}>
                {loading ? (
                  <div className="text-center py-5">
                    <Spinner color="primary" />
                    <p className="mt-2">Loading Invoice...</p>
                  </div>
                ) : error ? (
                  <Alert color="danger" className="text-center">
                    {error}
                  </Alert>
                ) : (
                  <Card className="shadow rounded border-0">
                    <CardBody>
                      <div className="invoice-top pb-4 border-bottom">
                        <Row>
                          <Col md="8">
                            <div className="logo-invoice mb-2 h4 fw-bold">
                              {invoice.businessName}
                            </div>
                            <p className="text-muted mb-0">
                              {invoice.industryId?.name} Industry
                            </p>
                          </Col>

                          <Col md="4" className="mt-4 mt-sm-0 text-md-end">
                            <Badge color={invoice.status === "ACTIVE" ? "success" : "warning"} className="mb-2">
                              {invoice.status}
                            </Badge>
                            <p className="text-muted mb-0">
                              <b>Date:</b> {new Date(invoice.createdAt).toLocaleDateString()}
                            </p>
                          </Col>
                        </Row>
                      </div>

                      <div className="invoice-middle py-4">
                        <Row>
                          <Col md="6">
                            <h5>Business Details :</h5>
                            <dl className="row mb-0">
                              <dt className="col-4 text-muted fw-normal">Name :</dt>
                              <dd className="col-8 text-dark">{invoice.businessId?.name}</dd>

                              <dt className="col-4 text-muted fw-normal">Address :</dt>
                              <dd className="col-8 text-muted">{invoice.address || invoice.businessId?.address}</dd>
                            </dl>
                          </Col>

                          <Col md="6" className="mt-4 mt-sm-0">
                            <h5>User Details :</h5>
                            <dl className="row mb-0">
                              <dt className="col-4 text-muted fw-normal">Name :</dt>
                              <dd className="col-8 text-dark">{invoice.userId?.name}</dd>

                              <dt className="col-4 text-muted fw-normal">Email :</dt>
                              <dd className="col-8 text-muted">{invoice.userId?.email}</dd>

                              <dt className="col-4 text-muted fw-normal">Mobile :</dt>
                              <dd className="col-8 text-muted">{invoice.userId?.mobile}</dd>
                            </dl>
                          </Col>
                        </Row>
                      </div>

                      <div className="invoice-description py-4 border-top">
                        <h5>Description :</h5>
                        <p className="text-muted">{invoice.description}</p>
                      </div>

                      <div className="invoice-photos py-4 border-top">
                        <h5>Attached Photos :</h5>
                        <Row>
                          {invoice.firstPhotoUrl && (
                            <Col md="6" className="mb-3">
                              <Card className="border-0 shadow-sm overflow-hidden">
                                <img src={invoice.firstPhotoUrl} alt="Invoice First" className="img-fluid rounded" />
                              </Card>
                            </Col>
                          )}
                          {invoice.secondPhotoUrl && (
                            <Col md="6" className="mb-3">
                              <Card className="border-0 shadow-sm overflow-hidden">
                                <img src={invoice.secondPhotoUrl} alt="Invoice Second" className="img-fluid rounded" />
                              </Card>
                            </Col>
                          )}
                          {!invoice.firstPhotoUrl && !invoice.secondPhotoUrl && (
                            <Col xs={12}>
                              <p className="text-muted italic">No photos attached.</p>
                            </Col>
                          )}
                        </Row>
                      </div>

                      <div className="invoice-footer border-top pt-4 text-center">
                        <p className="text-muted small mb-0">
                          This is a system-generated public invoice view for token: <br />
                          <span className="text-dark small">{invoice.uniqueToken}</span>
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                )}
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default withRouter(PublicInvoice);
